import { Outlet } from 'react-router-dom'

const AdminLayout: React.FC = () => <Outlet />

export default AdminLayout
